import { IconButton } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Dropdown } from '../../../../Dropdown'
import { Icon } from '../../../../Icon'

import * as S from './styles'

type UserDropdownProps = {
  id: string
  onEdit: (_id: string) => void
  setDeleteUser?: () => void
}

export const UserDropdown = ({
  id,
  onEdit,
  setDeleteUser
}: UserDropdownProps) => {
  const { t } = useTranslation()
  return (
    <S.Wrapper>
      <Dropdown
        title={
          <IconButton
            id="action"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {}}
            size="medium"
            edge="start"
          >
            <Icon
              icon="itens-interface-actions"
              width={12}
              height={12}
              aria-label="action"
            />
          </IconButton>
        }
      >
        <S.Nav>
          <Link to={`/usuario/editar/${id}`} onClick={() => onEdit(id)}>
            <S.Link>
              <Icon icon="dropdown-edit" height={16} width={16}></Icon>
              <span>{t('generalUserPage:actions:edit')}</span>
            </S.Link>
          </Link>
          <S.Link onClick={setDeleteUser}>
            <Icon icon="dropdown-delete" height={16} width={16}></Icon>
            <span>{t('generalUserPage:actions:delete')}</span>
          </S.Link>
        </S.Nav>
      </Dropdown>
    </S.Wrapper>
  )
}
